import Typography from 'components/generics/texts/Typography';
import Caret from 'public/assets/icons/caret_right.svg';
import React, { HTMLAttributes } from 'react';
import classes from './index.module.scss';

interface Props extends HTMLAttributes<HTMLDivElement> {
  text: string;
}

const BasePropertyShowAll = ({ text, ...props }: Props) => {
  return (
    <div
      className={classes.container}
      {...props}
    >
      <Typography className={classes.text}>{text}</Typography>
      <div className={classes.iconContainer}>
        <Caret className={classes.icon} />
      </div>
    </div>
  );
};

export default BasePropertyShowAll;
